'use client';

import React from 'react';
import CodeWrapper from './code-wrapper';

export const CodeGroup = ({ children }) => {
  const codeBlocks = React.Children.map(children, (child) => ({
    title: child.props.title,
    language: child.props.children.props.className?.split('-').pop() ?? '',
    code: child.props.children.props.children,
  }));

  return <CodeWrapper codeBlocks={codeBlocks} />;
};

export default CodeGroup;
